module.exports = __webpack_public_path__ + "img/growtech.a02b97bc.png";